import { render, staticRenderFns } from "./CustomLinkChrome.vue?vue&type=template&id=daf28886&scoped=true&"
import script from "./CustomLinkChrome.vue?vue&type=script&lang=js&"
export * from "./CustomLinkChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf28886",
  null
  
)

export default component.exports